import styles from "./Questions.module.scss";
import { useState } from "react";
import { MdOutlineAdd, MdOutlineHorizontalRule } from "react-icons/md";

export const Questions = () => {
  const [isQuestionOpen1, setIsQuestionOpen1] = useState(false);
  const [isQuestionOpen2, setIsQuestionOpen2] = useState(false);
  const [isQuestionOpen3, setIsQuestionOpen3] = useState(false);
  const [isQuestionOpen4, setIsQuestionOpen4] = useState(false);
  const toggle1 = () =>
    setIsQuestionOpen1((isQuestionOpen1) => !isQuestionOpen1);
  const toggle2 = () =>
    setIsQuestionOpen2((isQuestionOpen2) => !isQuestionOpen2);
  const toggle3 = () =>
    setIsQuestionOpen3((isQuestionOpen3) => !isQuestionOpen3);
  const toggle4 = () =>
    setIsQuestionOpen4((isQuestionOpen4) => !isQuestionOpen4);

  const {
    section__questions,
    questions__wrapper,
    questions__left,
    questions__title,
    questions__more,
    questions__right,
    questions__list,
    questions__element,
    questions__element_open,
  } = styles;

  return (
    <section className={section__questions}>
      <div className={questions__wrapper}>
        <div className={questions__left}>
          <h2
            className={questions__title}
            data-aos="fade-down"
            data-aos-delay="200"
          >
            Najczęściej zadawane <span>pytania</span>
          </h2>
          <div
            className={questions__more}
            data-aos="fade-left"
            data-aos-delay="400"
          >
            <ul>
              <li></li>
              <li></li>
              <li></li>
            </ul>
            <h3>Wciąż masz pytanie?</h3>
            <p>
              Z chęcią na nie odpowiem.<a href="#contact"> Napisz do mnie!</a>
            </p>
          </div>
        </div>
        <div
          className={questions__right}
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <ul className={questions__list}>
            <li
              className={
                isQuestionOpen1 ? questions__element_open : questions__element
              }
            >
              <h3>Czy publikacja strony w internecie jest darmowa?</h3>
              <p>
                Istnieją darmowe opcje publikacji strony internetowej, jednak
                mają one pewne ograniczenia. Darmowe usługi hostingowe często
                oferują subdomeny (np. twojastrona.wordpress.com) oraz
                ograniczoną przestrzeń na serwerze i funkcjonalność. Jeśli
                zależy Ci na profesjonalnym wyglądzie i większych możliwościach,
                takich jak własna domena (np. twojastrona.pl), to publikacja
                strony wiąże się z pewnymi kosztami, które obejmują wykupienie
                domeny i hosting.
              </p>
              <button onClick={toggle1} aria-label="otwórz">
                {isQuestionOpen1 ? (
                  <MdOutlineHorizontalRule />
                ) : (
                  <MdOutlineAdd />
                )}
              </button>
            </li>
            <li
              className={
                isQuestionOpen2 ? questions__element_open : questions__element
              }
            >
              <h3>Co to jest certyfikat SSL?</h3>
              <p>
                Certyfikat SSL (Secure Sockets Layer) zapewnia bezpieczne
                połączenie między przeglądarką użytkownika a serwerem, szyfrując
                wszystkie przesyłane dane. Certyfikat SSL jest szczególnie
                ważny, jeśli na stronie przechowujesz wrażliwe dane, takie jak
                dane logowania czy informacje płatnicze. Certyfikat SSL również
                wpływa na pozycjonowanie strony w wyszukiwarkach, ponieważ
                Google promuje strony z HTTPS. Wiele firm hostingowych oferuje
                darmowe certyfikaty SSL, np. Let's Encrypt, jednak można także
                wykupić płatny certyfikat SSL, który daje dodatkowe gwarancje i
                usługi.
              </p>
              <button onClick={toggle2} aria-label="otwórz">
                {isQuestionOpen2 ? (
                  <MdOutlineHorizontalRule />
                ) : (
                  <MdOutlineAdd />
                )}
              </button>
            </li>
            <li
              className={
                isQuestionOpen3 ? questions__element_open : questions__element
              }
            >
              <h3>Ile kosztuje hosting strony WWW?</h3>
              <p>
                Koszt hostingu zależy od wybranego planu, firmy hostingowej i
                rodzaju hostingu. Można znaleźć opcje zaczynające się od około
                100-150 zł rocznie dla prostych stron, takich jak blogi czy małe
                strony firmowe. Dla bardziej zaawansowanych potrzeb, takich jak
                duże sklepy internetowe czy strony z dużym ruchem, ceny hostingu
                mogą wynosić od 400 zł do kilku tysięcy złotych rocznie, w
                zależności od potrzeb (np. dedykowane serwery, VPS, hosting w
                chmurze).
              </p>
              <button onClick={toggle3} aria-label="otwórz">
                {isQuestionOpen3 ? (
                  <MdOutlineHorizontalRule />
                ) : (
                  <MdOutlineAdd />
                )}
              </button>
            </li>
            <li
              className={
                isQuestionOpen4 ? questions__element_open : questions__element
              }
            >
              <h3>Ile kosztuje utrzymanie strony WWW?</h3>
              <p>
                Utrzymanie strony WWW obejmuje koszty związane z hostingiem,
                zakupem i odnowieniem domeny (zwykle 200-400 zł rocznie),
                certyfikatem SSL (często darmowy, ale płatne opcje zaczynają się
                od około 100 zł rocznie), aktualizacjami systemu (jeśli używasz
                CMS, np. WordPress) oraz ewentualnymi kosztami utrzymania strony
                (np. zatrudnienie specjalisty do modyfikacji strony lub
                zarządzania jej treścią). Całkowite roczne koszty mogą wynosić
                od 300 zł do kilku tysięcy złotych, w zależności od skali strony
                i usług, które są niezbędne do jej utrzymania.
              </p>
              <button onClick={toggle4} aria-label="otwórz">
                {isQuestionOpen4 ? (
                  <MdOutlineHorizontalRule />
                ) : (
                  <MdOutlineAdd />
                )}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
